const containerSelector = '.block-carousel';

function initialiseCarousel(element) {
    setSliderWidth(element);
    createDots(element);

    let currentSlide = 0;
    const images = element.querySelectorAll('.slider img');  

    // Set left and right click handlers
    console.log(element.querySelector('.left'))
    element.querySelector('.left').addEventListener('click', () => {
        if(currentSlide === 0) return;
        currentSlide -= 1;
        gotoSlide(element, currentSlide);
    });

    element.querySelector('.right').addEventListener('click', () => {
        if(currentSlide >= images.length - 1) return;
        currentSlide += 1;
        gotoSlide(element, currentSlide);
    });
}

function gotoSlide(element, index) {
    element.querySelector('.slider').style.left = (-100 * index) + '%';
    highlightDot(element, index);
}

function setSliderWidth(element) {
    const images = element.querySelectorAll('.slider img');  
    element.querySelector('.slider').style.width = (100 * images.length) + '%';
}

function createDots(element) {
    const images = element.querySelectorAll('.slider img');
    const html = [].map.call(images, (k, i) => {
        return `<div class="dot ${(i === 0 ? 'active' : '')}" data-key="${i}"></div>`;
    }).join('');
    element.querySelector('.pagination').innerHTML = html;
}

function highlightDot(element, index) {
    const blocks = element.querySelectorAll('.dot');
    [].forEach.call(blocks, (elem) => {
        elem.classList.remove('active');
    });

    element.querySelector(`.dot:nth-child(${index + 1})`).classList.add('active');


}

function init() {
    const blocks = document.querySelectorAll(containerSelector);
    [].forEach.call(blocks, initialiseCarousel);
}

module.exports = {
    init: init
}



// WEBPACK FOOTER //
// ./assets/js/Carousel.js